module.exports = __webpack_public_path__ + "childALQ-4970bf4ca695e1766803bdba2c807ed2.png";